import { site } from "@/site";

// Screen first: a screen reader announces the title on every navigation, and two tabs reading
// only the product name are indistinguishable.
export function pageTitle(
  ...parts: readonly (string | null | undefined)[]
): string {
  return [...parts.filter(Boolean), site.name].join(" · ");
}
